export default __webpack_public_path__ + "a2b09ca7e926bcfcce84f035bcb36f0e.svg";